// extracted by mini-css-extract-plugin
export default {"setSquareImage":"PIMoreFromItem_setSquareImage__jTQUE"};